export const settings = ({ settings }) => {
  return {
    notify: {
      schedule: true,
      cancel: true,
      transfer: false,
      send: {
        email: true,
        sms: false,
        push: {
          web: true,
          app: false
        }
      },
      dependents: false,
      dependent: [],
      weeklySchedule: false,
      weeklySummary: false,
      supportStatistics: false,
      integration: {
        offline: false,
        ownApi: false,
        medibookApi: false
      }
    },
    ...settings
  }
}



// WEBPACK FOOTER //
// ./src/store/getters/settings.js